import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  partnerBox: {
    width: "100%",
    padding: theme.spacingRules.cardPaddingDesktop,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    backgroundColor: "transparent",
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacingRules.cardPaddingMobile,
      margin: "auto",
    },
  },
  maxWidth: {
    maxWidth: "1140px",
    width: "100%",
    [theme.breakpoints.down("sm")]: {
      maxWidth: "500px",
    },
  },
  styledHeadingText: {
    fontSize: "18px !important",
    fontWeight: "400 !important",
    color: theme.agentTheme.card.foreground,
    marginBottom: "10px !important",
    textAlign: "center !important",
    [theme.breakpoints.down("sm")]: {
      fontSize: "16px !important",
    },
  },

  headingText: {
    fontSize: "28px !important",
    fontWeight: "600 !important",
    color: theme.agentTheme.background.primary_text,

    [theme.breakpoints.down("sm")]: {
      fontSize: "24px !important",
    },
  },

  iconStyle: {
    width: "60px",
    height: "40px",
    backgroundColor: theme.agentTheme.secondary?.main,
    color: theme.agentTheme.secondary?.foreground,
    borderRadius: 0,
    "&:hover": {
      backgroundColor: theme?.agentTheme?.primary?.main,
      color: theme.agentTheme.primary?.foreground,
    },
  },
  partnerItem: {
    width: "133px",
    height: "133px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    overflow: "hidden",
    borderRadius: "2px",
    marginRight: "2rem",
    flexShrink: 0,
    backgroundColor: "transparent",
    boxShadow: "0 0 8px #0000001a",
    padding: "5px",
    cursor: "pointer",
    transition: "transform 0.3s ease",
    "& img": {
      width: "100%",
      height: "100%",
      objectFit: "cover",
      display: "block",
      transition: "transform 0.3s ease",
    },
    "&:hover img": {
      transform: "scale(1.2)",
    },
    [theme.breakpoints.down("sm")]: {
      width: "105px",
      height: "105px",
      marginRight: "1rem",
    },
  },

  partnersContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "60px",
    maxWidth: "800px",
    width: "100%",
    padding: "20px 0",
    [theme.breakpoints.down("sm")]: {
      gap: "30px",
      flexDirection: "column",
    },
  },

  partnerWrapper: {
    flex: "0 0 auto",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },

  partnerIcon: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "20px",
    backgroundColor: "transparent",
    borderRadius: "12px",

    [theme.breakpoints.down("sm")]: {
      padding: "15px",
    },
  },

  partnerLogo: {
    height: "90px !important",
    width: "207px",
    maxWidth: "207px",
    objectFit: "contain",
  },

  paginationContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginTop: "40px",
    gap: "10px",
  },

  paginationDot: {
    width: "12px",
    height: "12px",
    borderRadius: "50%",
    backgroundColor: theme.agentTheme.primary.foreground,
    cursor: "pointer",
    transition: "all 0.3s ease",
    "&:hover": {
      backgroundColor: theme.agentTheme.primary.foreground,
      transform: "scale(1.2)",
    },
  },

  paginationDotActive: {
    backgroundColor: `${theme.agentTheme.primary.main} !important`,
    transform: "scale(1.3)",
    boxShadow: "0 2px 8px rgba(255, 122, 90, 0.4)",
  },

  viewAllContainer: {
    marginTop: "40px",
    display: "flex",
    justifyContent: "center",
  },

  viewAllButton: {
    backgroundColor: `${theme.agentTheme.primary.main} !important`,
    color: `${theme.agentTheme.primary.foreground} !important`,
    padding: "12px 32px !important",
    fontSize: "14px !important",
    fontWeight: "600 !important",
    textTransform: "uppercase !important",
    letterSpacing: "1px !important",
    borderRadius: "8px !important",
    transition: "all 0.3s ease !important",
    "&:hover": {
      backgroundColor: `${theme.agentTheme.primary.main} !important`,
      transform: "translateY(-2px)",
    },
    [theme.breakpoints.down("sm")]: {
      padding: "10px 24px !important",
      fontSize: "12px !important",
    },
  },
  navButton: {
    border: `1.5px solid ${theme?.agentTheme?.text?.small_text_color}`,
    borderRadius: "50%",
    width: 50,
    height: 50,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: theme?.agentTheme?.text?.small_text_color,
    backgroundColor: "transparent",
    transition: "all 0.3s ease",
    "& svg": {
      fontSize: 22,
    },
    "&:hover": {
      backgroundColor: theme?.agentTheme?.primary?.main,
      borderColor: theme?.agentTheme?.primary?.foreground,
      color: theme?.agentTheme?.primary?.foreground,
    },
    "&:active": {
      transform: "scale(0.96)",
    },
    [theme.breakpoints.down("sm")]: {
      width: 30,
      height: 30,
      marginTop: "0.5rem",
      "& svg": {
        fontSize: 16,
      },
    },
  },
carouselWrapper: {
    overflow: "hidden",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },

  track: {
    display: "flex",
    gap: "10px",
  },

  slideNext: {
    transition: "transform 0.8s ease-in-out",
    transform: "translateX(-300px)", 
  },

  reset: {
    transition: "none",
    transform: "translateX(0)",
  },

  slidePrev: {
    transition: "transform 0.8s ease-in-out",
    transform: "translateX(300px)", 
  },

}));

export default useStyles;
